<template>
  <VDataGridV2
      :loader="dataLoader"
      paginated
  >
    <VDataGridColumnV2
        id="authorId"
        label="Автор"
        filterable
        filter-type="select"
        :filter-props="authorFilterProps"
        width="170px"
				content-class="ellipsis"
    >
      <template #default="{ row }">
        <template v-if="row.author">
          <div class="ellipsis">{{ row.author.name }}</div>
          <div class="description">ID: {{ row.author.id }}</div>
        </template>
        <template v-else>Создано автоматически</template>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="partnerId"
        label="Партнер"
        filterable
        filter-type="select"
        :filter-props="partnerFilterProps"
        width="160px"
        content-align="center"
				content-class="ellipsis"
    >
      <template #default="{ row }">
        <div
            v-if="row.parentEntity && row.parentEntity.id"
            class="description"
        >
          ID: {{ row.parentEntity.id }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="entityTypeName"
        label="Тип объекта"
        width="200px"
        content-align="center"
        filterable
        filter-type="select"
        :filter-props="entityTypeFilterProps"
				content-class="ellipsis"
    >
      <template #default="{ row }">
        <div
					class="ellipsis"
				>
					{{ row.entityTypeName }}
				</div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="entityPattern"
        label="Объект"
        content-align="right"
        filterable
        :filter-props="entityPatternFilterProps"
        width="200px"
				content-class="ellipsis"
    >
      <template #default="{ row }">
        <div class="ellipsis"
            :title="row.parentEntity.name || row.parentEntity.id"
        >
          {{ row.parentEntity.name || row.parentEntity.id }}
        </div>

        <div v-if="row.parentEntity.name !== null" class="description">
          <span>ID:</span>
          {{ $core.utils.string.formatWithDelimiter(row.parentEntity.id) }}
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="eventTypeName"
        label="Тип события"
        width="110px"
        content-align="center"
        filterable
        filter-type="select"
        :filter-props="eventTypeFilterProps"
    >
      <template #default="{ row }">
        {{ row.eventActionName }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="eventTime"
        label="Дата"
        filterable
        width="100px"
        filter-type="date-range"
        :filter-props="eventTimeFilterProps"
        content-align="center"
				content-class="nowrap"
    >
      <template #default="{ row }">
        {{ $core.utils.date.humanizeDate(row.eventTime) }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="entityVersion"
        label="Версия"
        width="50px"
        content-align="center"
    >
      <template #default="{ row }">
        {{ row.parentEntity.version }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="changes"
        label="Изменения"
        width="220px"
        filterable
        filter-type="select"
        :filter-props="changesFilterProps"
    >
      <template #default="{ row }">
        <div v-if="row.eventTypeName === 'update'" class="description">
          <div
              v-for="(change, index) in row.changeRecords"
              :key="row.id + '-' + index"
              v-html="change"
          />
        </div>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
        id="reason"
        label="Причина"
        width="160px"
    >
      <template #default="{ row }">
        <div v-if="row.reasonText" class="ellipsis" :title="row.reasonText">
          {{ row.reasonText }}
        </div>
      </template>
    </VDataGridColumnV2>
  </VDataGridV2>
</template>

<script lang="ts">
import { getEntityTypeOptions } from "@/core/services/Changelogs/EntityRegistry";

import ChangelogsService from '@/core/services/Changelogs/ChangelogsService';
import DataGridLoader    from '@/lib/components/VDataGridV2/DataGridLoader';

import PartnersService from '@/domains/Partners/PartnersService';
import PersonsService  from '@/domains/Persons/PersonsService';

export default defineComponent({
  name: 'ChangelogsRegistry',

  setup() {
    return {
      authorFilterProps:        { searchFunction: (pattern: string) => PersonsService.searchPersons(pattern), placeholder: 'Имя, email или id', clearable: true },
      partnerFilterProps:       { searchFunction: (pattern: string) => PartnersService.getList(pattern), placeholder: 'Название или id', clearable: true },
      entityPatternFilterProps: { placeholder: 'Название или id', clearable: true },
      eventTimeFilterProps:     { clearable: true },

      entityTypeOptions: getEntityTypeOptions(),
      eventTypeOptions:  Object.entries(ChangelogsService.EVENT_TYPE_LABELS).map(([id, name]) => ({ id, name })),
    };
  },

  data() {
    return {
      dataLoader: new DataGridLoader(ChangelogsService.getListPaginated),
    };
  },

  computed: {
    entityTypeFilterProps() {
      return { options: this.entityTypeOptions };
    },

    eventTypeFilterProps() {
      return { options: this.eventTypeOptions };
    },

    changesFilterProps() {
      return { disabled: this.isChangesFilterDisabled };
    },

    isChangesFilterDisabled(): boolean {
      return ChangelogsService.isChangesFilterApplicable(
          this.dataLoader.filters as { entityTypeName?: string; eventTypeName?: string },
      ) === false;
    },
  },
});
</script>